/*
This is your local config file. It is gitignored. Export an object with
any of the config keys to override them for local development.
Exporting an empty object is a no-op.

Example (local sling-server and sling-io):

export default {
  API_END_POINT: 'http://local-api.getsling.com/v1/',
  WEBSOCKETS_END_POINT: 'http://local-socket.getsling.com/sockjs',
  INCLUDE_MEMORY_LEAKS_DIAGNOSTICS: false,
};
*/

export default {};
